import { styled } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

export const StyledTypographyPrice = styled(Typography)(({ theme }) => ({
  fontSize: 26,
  fontWeight: 700,
  display: "inline-block",
  color: theme.palette.secondary.dark,
  [theme.breakpoints.down("xs")]: {
    fontSize: 22,
  },
}));
